import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { Match } from "@reach/router"
import AniLink from "gatsby-plugin-transition-link/AniLink"

const Header = ({ toggleModalVisibility }) => {
  return (
    <>
      <header id="header" className="top">
        <div className="container">
          <nav className="navigation-menu">
            <nav className="left">
              <Match path="/services/*">
                {props => {
                  return props.match ? (
                    <Link
                      id="service-nav"
                      to="/#services"
                      className="active"
                      activeClassName="active"
                      partiallyActive={true}
                    >
                      <span>SERVICES</span>
                    </Link>
                  ) : (
                    <Link
                      id="service-nav"
                      to="/#services"
                      activeClassName="active"
                    >
                      <span>SERVICES</span>
                    </Link>
                  )
                }}
              </Match>
              <AniLink
                fade
                to="/blog"
                partiallyActive={true}
                activeClassName="active"
              >
                <span>BLOG</span>
              </AniLink>
            </nav>
            <AniLink fade to="/" className="home-link">
              <img
                className="logo"
                src={"/images/control-gap-full-logo-white.svg"}
                alt="logo"
              />
            </AniLink>
            <nav className="right">
              <a href="tel:1-866-644-8808" className="phone-number">
                <span>1.866.644.8808</span>
              </a>
              <button
                onClick={toggleModalVisibility}
                className="button-component contact-button"
              >
                <span>CONTACT</span>
              </button>
            </nav>
          </nav>
        </div>
      </header>
    </>
  )
}
Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: `Control Gap`,
}

export default Header
